import React, { forwardRef } from "react";

import { Input } from "@shared/components/DataEntry";

import { FormField } from "../FormField";
import { FormInputProps } from "../../types";

export const FormInput = forwardRef<HTMLInputElement, FormInputProps>(({ name, ...props }, ref) => (
  <FormField name={name}>
    <Input name={name} ref={ref} {...props} />
  </FormField>
));

FormInput.displayName = "Form.Input";
